import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { inRoomDiningAllergensSelector } from '../../../servicesSlice';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';

const ItemAllergensList = (props) => {
  const { selectedItem } = props;
  const [loading, setLoading] = useState(true);
  const originalAllergens = useSelector(inRoomDiningAllergensSelector);
  const [itemAllergens, setItemAllergens] = useState([]);

  useEffect(() => {
    const tempItemAllergens = originalAllergens.filter((item) => {
      return selectedItem?.allergens?.includes(item.id);
    });
    setItemAllergens(tempItemAllergens);
    setLoading(false);
  }, [selectedItem, originalAllergens]);

  return (
    <>
      {loading ? (
        <div className='pt-4 col-md-12'>
          <LinearProgressBar />
        </div>
      ) : (
        <>
          <div className='row'>
            <div className='col-md-12'>
              <div className='details-label mb-2'>Allergens</div>
              {itemAllergens?.length > 0 ? (
                itemAllergens.map((allergen, index) => (
                  <div className='details-value' key={index}>
                    {allergen.name}
                  </div>
                ))
              ) : (
                <div className='details-value'>---</div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ItemAllergensList;
